import { createMuiTheme } from "@material-ui/core/styles";
import { isStaging } from "../utilities";
import stagingTheme from "./stagingTheme";
import productionTheme from "./productionTheme";

let myTheme;

if (isStaging()) {
    myTheme = createMuiTheme(stagingTheme);
} else {
    myTheme = createMuiTheme(productionTheme);
}

export default myTheme;



// WEBPACK FOOTER //
// ./src/common/themes/index.js